export type EstadoCola = 'pendiente' | 'aprobado' | 'rechazado'

export interface ColaItem {
  id: string
  [key: string]: unknown
}

export interface ColaListResponse {
  total: number
  // El microservicio no devuelve paginación para /cola (solo {total, items}).
  pagina?: number | null
  por_pagina?: number | null
  items: ColaItem[]
}

export interface ColaFilters {
  estado?: EstadoCola
  pagina?: number
  por_pagina?: number
}

export const ESTADOS_COLA: { value: EstadoCola; label: string }[] = [
  { value: 'pendiente', label: 'Pendientes' },
  { value: 'aprobado', label: 'Aprobados' },
  { value: 'rechazado', label: 'Rechazados' },
]
